import React from "react";
import { SectionCard } from "../Ui";
import { formatListDate } from "../../lib/purchaseListMeta";
import { plantReportTypeLabel } from "../../lib/plantLabConfig";
import LabReportReceiptActions from "./LabReportReceiptActions";

export default function PlantLabRegister({ reports = [], testId = "plant-lab-register" }) {
  return (
    <SectionCard title={`In-plant lab register (${reports.length})`} testId={testId}>
      <p className="text-xs text-muted-foreground mb-3">
        Machine and in-plant quality readings — print or download PDF.
      </p>
      <div className="overflow-x-auto rounded-md border border-border">
        <table className="w-full text-sm min-w-[560px]">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-widest text-muted-foreground bg-muted/40">
              <th className="px-3 py-2.5">Date</th>
              <th className="px-3 py-2.5">Type</th>
              <th className="px-3 py-2.5">By</th>
              <th className="px-3 py-2.5">Notes</th>
              <th className="px-3 py-2.5 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((r) => (
              <tr key={r.id} className="border-t border-border hover:bg-muted/20">
                <td className="px-3 py-2.5 text-xs whitespace-nowrap">{formatListDate(r.created_at) || "—"}</td>
                <td className="px-3 py-2.5 text-xs">{plantReportTypeLabel(r.report_type)}</td>
                <td className="px-3 py-2.5 text-xs">{r.created_by || "—"}</td>
                <td className="px-3 py-2.5 text-xs text-muted-foreground max-w-[200px] truncate">{r.notes || "—"}</td>
                <td className="px-3 py-2.5">
                  <LabReportReceiptActions
                    reportId={r.id}
                    kind="plant"
                    label={r.report_type}
                  />
                </td>
              </tr>
            ))}
            {reports.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center py-10 text-muted-foreground">No in-plant reports yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </SectionCard>
  );
}
